import React,{ useEffect, useState, useRef } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {Link} from 'react-router-dom';
import ProfileInfo from '../components/Visitor/ProfileInfo';
import Preferences from '../components/Visitor/Preferences';
import PointsVisited from '../components/Visitor/PointsVisited';


const NavContainer = styled("nav")`
  display: flex;
  justify-content: center;
  padding: 30px 20px;
  background-color: transparent;
  align-items:center;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
    font-size: 14px;
   
  }

  @media (max-width: 480px) {
    padding: 15px 5px;
  }
`;


const NavTabs = styled("ul")`

   display: flex;
  list-style: none;
  align-items: center;
  gap: 20px;
  padding: 0;

  & > li {

    a {
      text-decoration: none;
      color: #385963;
      font-weight: 500;
      padding: 10px 0px;
      margin: 0 10px;
      position: relative;
      transition: color 0.4s;

      &:hover {
        color: #91abb3;
      }

      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 50%;
        background-color: #538392;
        transition: all 0.4s;
      }

      &:hover::before {
        width: 100%;
        left: 0;
      }

      &.active-tab {
        color: #91abb3;

        &::before {
          width: 100%;
          left: 0;
        }
      }
    }

    &:last-of-type {
      margin-right: 0;
    }
  }

   
    @media (max-width: 1200px) {
      display: flex;
      align-items: center;
      a {
        font-size: 16px; 
        white-space: normal; 
        text-align: center; 
      }
    }
    @media (max-width: 992px) {
      a {
        font-size: 14px; 
        white-space: normal; 
        text-align: center; 
      }
    }
    @media (max-width: 768px) {
      a {
        font-size: 12px; 
        white-space: normal; 
        text-align: center;
         margin:0px;
      }
    }
    @media (max-width: 576px) {
      a {
        font-size: 10px; 
        white-space: normal; 
        text-align: center; 
         margin:0px;
      }
    }
  }
`;


const MainBody = styled.div`
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;


const ProfileMenuVisitor = () => {

const BASE_URL = process.env.REACT_APP_BASE_URL;
const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
const tokenString = sessionStorage.getItem("token") ;
const location = useLocation();
const { state } = location;
const [profile, setProfile] = useState({}); 
const getInitialTab = () => localStorage.getItem('activeTab') || state?.activeComponent || 'crudProfileVisitor';
const [activeComponent, setActiveComponent] = useState(getInitialTab);
const { i18n } = useTranslation();
const currentLanguage = i18n.language;

  useEffect(() => {
    if (state?.activeComponent) {
        setActiveComponent(state.activeComponent);
    }
  }, [state]);

  useEffect(() => {
    localStorage.setItem('activeTab', activeComponent);
  }, [activeComponent]);

    const handleTabClick = (componentName) => {
      setActiveComponent(componentName);
    };

    useEffect(() => {
       const fetchRegisteredUserProfile = async () => {
         try {
          
           const response = await fetch(
             `${BASE_URL}RegisteredUserProfile/get`,
             {
               method: "GET",
               headers: {
                 "Content-Type": "application/json",
                 "Authorization": `Bearer ${tokenString}` 
               }
             }
           );
           if (!response.ok) {
             throw new Error(`HTTP error! status: ${response.status}`);
           }
           
           const profile = await response.json();
           setProfile(profile);
          
         } catch (error) {
           console.error('Error fetching destination categories:', error);
          
         }
       };
     
       fetchRegisteredUserProfile();
     }, []);


  return (
    <>
          <NavContainer>
              <NavTabs>
                  <li>
                    <Link
                      to=""
                      className={activeComponent === 'crudProfileVisitor' ? 'active-tab' : ''}
                      onClick={() => handleTabClick("crudProfileVisitor")}
                      style={{
                        fontWeight: activeComponent === 'crudProfileVisitor' ? 'bold' : 'normal',
                        color: activeComponent === 'crudProfileVisitor' ? '#91abb3' : '#385963'
                      }}
                    >
                      {i18n.t('manageProfile')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to=""
                       className={activeComponent === 'preferences' ? 'active-tab' : ''}
                       onClick={() => handleTabClick("preferences")}
                       style={{
                         fontWeight: activeComponent === 'preferences' ? 'bold' : 'normal',
                         color: activeComponent === 'preferences' ? '#91abb3' : '#385963'
                       }}
                    >
                    {i18n.t('preferences')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to=""
                      className={activeComponent === 'pointsVisited' ? 'active-tab' : ''}
                      onClick={() => handleTabClick("pointsVisited")}
                      style={{
                         fontWeight: activeComponent === 'pointsVisited' ? 'bold' : 'normal',
                         color: activeComponent === 'pointsVisited' ? '#91abb3' : '#385963'
                       }}
                    >
                        {i18n.t('pointsOfInterest')} 
                    </Link>
                  </li>
              </NavTabs>
          </NavContainer>
         
  
      <MainBody>
        {activeComponent === 'crudProfileVisitor' && <ProfileInfo profile={profile}/>}
        {activeComponent === 'preferences' && <Preferences  profile={profile} setProfile={setProfile}/>}
        {activeComponent === 'pointsVisited' && <PointsVisited  profile={profile}/>}
      </MainBody> 
      </>
  )
}

export default ProfileMenuVisitor
